import { Component, EventEmitter, Input, Output } from '@angular/core';
import { DividerComponent } from '@shared/components/commons/divider/divider.component';
import { Trust } from '@models/trusts/trust';
import { XpmCardProfileComponent } from "@shared/components/entity-profiles/xpm-card-profile/xpm-card-profile.component";
import { EntityType } from '@models/common/entity-type.enum';

@Component({
  selector: 'app-trust-profile-card',
  standalone: true,
  imports: [
    DividerComponent,
    XpmCardProfileComponent
],
  templateUrl: 'trust-profile-card.component.html',
  styleUrl: 'trust-profile-card.component.scss'
})
export class TrustProfileCardComponent {
  @Input() trustProfile!: Trust;
  @Input() isDocumentsLoading = false;
  @Input() disableControls = false;
  @Input() showXpm = false;
  @Input() pendingDocumentsQuantity: number | null = null;

  @Output() onTrustRefreshed = new EventEmitter<void>();

  entityType: EntityType = EntityType.Trust;

  onTrustRefreshedEvent() {
    this.onTrustRefreshed.emit();
  }
}
